import { __rest } from "tslib";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Ellipsis, { extractEllipsisProps } from '../common/Ellipsis';
import { st, classes } from './Heading.st.css.js';
import { EllipsisCommonProps } from '../common/PropTypes/EllipsisCommon';
import deprecationLog from '../utils/deprecationLog';
import { WixStyleReactMaskingContext } from '../WixStyleReactMaskingProvider/context';
import { WixStyleReactContext } from '../WixStyleReactProvider/context';
export const APPEARANCES = {
    H1: 'H1',
    H2: 'H2',
    H3: 'H3',
    H4: 'H4',
    H5: 'H5',
    H6: 'H6',
};
export const SIZES = {
    extraLarge: 'H1',
    large: 'H2',
    medium: 'H3',
    small: 'H4',
    tiny: 'H5',
    extraTiny: 'H6',
};
const Heading = props => {
    const { ellipsisProps, componentProps } = extractEllipsisProps(props);
    const { light, appearance, as, children, dataHook, size, id } = componentProps, headingProps = __rest(componentProps, ["light", "appearance", "as", "children", "dataHook", "size", "id"]);
    useEffect(() => {
        if (appearance) {
            deprecationLog('<Heading/> - prop "appearance" is deprecated and will be removed in next major release, please use "size" property instead.');
        }
    }, [appearance]);
    const headingType = SIZES[size] || appearance || SIZES.extraLarge;
    return (React.createElement(WixStyleReactMaskingContext.Consumer, null, ({ maskingClassNames }) => (React.createElement(WixStyleReactContext.Consumer, null, ({ newColorsBranding }) => (React.createElement(Ellipsis, Object.assign({}, ellipsisProps, { wrapperClassName: st(classes.root, {
            appearance: headingType,
            size: newColorsBranding ? size : undefined,
        }), render: ({ ref, ellipsisClasses }) => React.createElement(as || headingType.toLowerCase(), Object.assign(Object.assign({}, headingProps), { id,
            ref, 'data-hook': dataHook, className: st(classes.root, { light, appearance: headingType, newColorsBranding }, ellipsisClasses(props.className), maskingClassNames), 'data-appearance': appearance, 'data-size': size, 'data-light': light, 'data-mask': !!maskingClassNames, 'data-id': id }), children) })))))));
};
Heading.displayName = 'Heading';
Heading.propTypes = Object.assign(Object.assign({}, EllipsisCommonProps), { 
    /** Applies a data-hook HTML attribute that can be used in the tests. */
    dataHook: PropTypes.string, 
    /** Renders any kind of content within a heading. Usually it’s a text string. */
    children: PropTypes.any, 
    /** Invert heading style so it can be used on a dark or image background. */
    light: PropTypes.bool, 
    /** this prop is deprecated and should not be used
     * @deprecated
     */
    appearance: PropTypes.oneOf(Object.keys(APPEARANCES)), 
    /** Renders the heading as any other given HTML tag */
    as: PropTypes.string, 
    /** Controls the heading's visual size and HTML tag appearance. HTML tag can be overridden with ‘as’ prop. */
    size: PropTypes.oneOf(Object.keys(SIZES)), 
    /** Identifies the element that labels or describes the text element */
    id: PropTypes.string });
Heading.defaultProps = Object.assign({ light: false }, Ellipsis.defaultProps);
export default Heading;
//# sourceMappingURL=Heading.js.map